import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';
import nl from './locales/nl.json';

// Available languages
export const availableLanguages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' }
];

// Resources object with all translations
const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de },
  nl: { translation: nl },
  it: { translation: it },
  pt: { translation: pt },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  ar: { translation: ar }
};

// Initialize i18n
i18n
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Pass to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback to English if language not available
    supportedLngs: ['en', 'fr', 'es', 'de', 'nl', 'it', 'pt', 'zh', 'ja', 'ko', 'ar'],
    
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache the language in localStorage
      caches: ['localStorage'],
      // Key to store language in localStorage
      lookupLocalStorage: 'vinisysLanguage',
    },
    
    interpolation: {
      escapeValue: false // React already protects from XSS
    },
    
    react: {
      useSuspense: false // Don't use Suspense for SSR compatibility
    }
  });

// Function to change language manually
export const changeLanguage = (languageCode) => {
  i18n.changeLanguage(languageCode);
  localStorage.setItem('vinisysLanguage', languageCode);
  
  // Handle RTL for Arabic
  if (languageCode === 'ar') {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  } else {
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = languageCode;
  }
};

// Get current language
export const getCurrentLanguage = () => {
  return i18n.language || 'en';
};

// Initialize direction based on current language
const currentLang = getCurrentLanguage();
if (currentLang === 'ar') {
  document.documentElement.dir = 'rtl';
} else {
  document.documentElement.dir = 'ltr';
}
document.documentElement.lang = currentLang;

export default i18n;
